import {
    DELETE_CANDIDATE_FEEDBACK_REQUEST,
    DELETE_CANDIDATE_FEEDBACK_SUCCESS,
    DELETE_CANDIDATE_FEEDBACK_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const deleteCandidateFeedBackReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_CANDIDATE_FEEDBACK_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case DELETE_CANDIDATE_FEEDBACK_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case DELETE_CANDIDATE_FEEDBACK_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default deleteCandidateFeedBackReducer;
